import { render, staticRenderFns } from "./NewspaperPreview.vue?vue&type=template&id=778a819d"
import script from "./NewspaperPreview.vue?vue&type=script&lang=js"
export * from "./NewspaperPreview.vue?vue&type=script&lang=js"
import style0 from "./NewspaperPreview.vue?vue&type=style&index=0&id=778a819d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports